import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion';
import helpIcon from '../../../assets/images/help-icon.svg';
import helpSolidBlue from '../../../assets/images/help-icon-blue.svg';
import PropTypes from 'prop-types';
import { TooltipContainer as Tooltip } from './Tooltip';
import { appSelectors } from '../reducer/app-reducer';

let isRtl = false;

const HelpButtonButton = styled.div(() => {
  let style = {
    display: 'inline-block',
    marginTop: '3px',
    verticalAlign: 'top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundImage: 'url(' + helpIcon + ')',
    ':hover': {
      backgroundImage: 'url(' + helpSolidBlue + ')'
    },
    width: '12px',
    height: '12px'
  };
  if (isRtl) {
    style.marginRight = '8px';
  } else {
    style.marginLeft = '8px';
  }
  return style;
});

//*********************************************
class HelpButton extends PureComponent {
  componentWillMount = () => {
    this.setState({
      showingTooltip: false
    });
  };

  showTooltip = () => {
    this.setState({
      showingTooltip: true
    });
  };

  hideTooltip = () => {
    this.setState({
      showingTooltip: false
    });
  };

  render = () => {
    isRtl = this.props.isInterfaceRtl;

    let tooltip = null;
    if (this.props.lionLoaded && this.state.showingTooltip) {
      tooltip = (
        <Tooltip
          tipText={this.props.lionTranslateString(this.props.helpTextKey)}
          tippedElement={this}
          tipPosition={this.props.tipPosition}
        />
      );
    }
    return (
      <HelpButtonButton onMouseOver={this.showTooltip} onMouseOut={this.hideTooltip}>
        {tooltip}
      </HelpButtonButton>
    );
  };
}

HelpButton.propTypes = {
  helpTextKey: PropTypes.string.isRequired,
  tipPosition: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {};
export const HelpButtonContainer = connect(
  mapStateToProps,
  wrapActions
)(HelpButton);



// WEBPACK FOOTER //
// ./src/modules/app/util/HelpButton.jsx